import { IBaseState } from "../../index";
import {
  ILargeMailingModel,
  LargeMailingModel,
} from "../../../models/report";

/**
 *
 */
export interface ILargeMailingState extends IBaseState<{}, {}> {
  service?: {};
  propertyService?: {};
  demandService?: {};
  personService?: {};
  largeMailing?: ILargeMailingModel;
    demandInfos?: any;
    personInfos?: any;
}

/**
 * define report state by vuex
 */
export class LargeMailingState implements ILargeMailingState {
  service?: {};
  propertyService?:{};
  demandService?: {};
  personService?: {};
  largeMailing?: ILargeMailingModel;
    demandInfos?: any;
    personInfos?: any;
  constructor(options: ILargeMailingState) {
    this.largeMailing = new LargeMailingModel();
    this.service = options.service;
    this.propertyService = options.propertyService;
    this.demandService = options.demandService;
    this.personService = options.personService;
      this.demandInfos = options.demandInfos || [];
      this.personInfos = options.personInfos || [];
  }
}
